import { isMultiValueSearchField } from 'modules/domains/segmentation/utils/isMultiValueSearchField';
import { convertListIdsToOptions } from '../utils';
import { useConditionState } from '../../../../hooks';
import { useMultiSelectInputContext } from '../../contexts';

export const useListMembershipSelectedOptions = () => {
  const [searchField] = useConditionState();
  const { lists } = useMultiSelectInputContext();
  return isMultiValueSearchField(searchField)
    ? convertListIdsToOptions(searchField.values, lists)
    : [];
};
